import { IconClose } from "../../icon/variants/IconClose.js";
import { IconVisibility } from "../../icon/variants/IconVisibility.js";
import { IconVisibilityOff } from "../../icon/variants/IconVisibilityOff.js";
import { IconButton } from "../../icon-button/IconButton.js";
import { VerticalDivider } from "../../divider/variants/VerticalDivider.js";
import { FormFieldError } from "../form-field-error/FormFieldError.js";
import inputs_module_default from "../inputs.module.js";
import { Flex, PasswordInput } from "@mantine/core";
import { useCallback, useMemo, useRef } from "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { useDisclosure } from "@mantine/hooks";

//#region src/components/inputs/password-input/PasswordInput.tsx
const CustomRightSection = ({ reveal, toggle, clear, hasValue }) => /* @__PURE__ */ jsxs(Flex, {
	direction: "row",
	gap: "xs",
	mr: "xs",
	children: [hasValue ? /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(IconButton, {
		color: "gray",
		withStyles: false,
		Icon: IconClose,
		onClick: clear
	}), /* @__PURE__ */ jsx(VerticalDivider, {})] }) : null, /* @__PURE__ */ jsx(IconButton, {
		color: "gray",
		withStyles: false,
		Icon: reveal ? IconVisibility : IconVisibilityOff,
		onClick: toggle
	})]
});
/**
*  A component that captures password data from users and provides an option to toggle password visibility
*/
const PasswordInput$1 = ({ defaultValue, description, disabled, error, label, leftSection, name, onBlur, onChange, onClick, onFocus, onKeyUp, placeholder, value, "data-testid": testId }) => {
	const [visible, { toggle }] = useDisclosure(false);
	const inputRef = useRef(null);
	const handleClear = useCallback(() => onChange?.(""), [onChange]);
	const handleChange = useCallback((e) => onChange?.(e.target.value), [onChange]);
	const hasValue = value?.toString().trim().length !== 0;
	const err = useMemo(() => {
		if (error && typeof error === "boolean") return true;
		if (error && typeof error === "string") return /* @__PURE__ */ jsx(FormFieldError, { errText: error });
		return null;
	}, [error]);
	return /* @__PURE__ */ jsx(PasswordInput, {
		required: true,
		ref: inputRef,
		"data-testid": testId,
		classNames: {
			...inputs_module_default,
			innerInput: inputs_module_default.passwordInput
		},
		autoComplete: "off",
		radius: "xxs",
		onClick,
		value: value ?? defaultValue,
		description,
		name,
		label,
		disabled,
		leftSection,
		onBlur,
		onChange: handleChange,
		onFocus,
		onKeyUp,
		placeholder,
		size: "xl",
		visible,
		labelProps: { "data-floating": hasValue },
		inputSize: "sm",
		rightSection: /* @__PURE__ */ jsx(CustomRightSection, {
			reveal: visible,
			toggle,
			clear: handleClear,
			hasValue
		}),
		descriptionProps: { className: disabled ? inputs_module_default.descriptionDisabled : inputs_module_default.description },
		error: err,
		inputWrapperOrder: error ? [
			"label",
			"input",
			"error"
		] : [
			"label",
			"input",
			"description"
		]
	});
};

//#endregion
export { PasswordInput$1 as PasswordInput };